import errorParser from '../../utils/errorParser'
import RestResourceService from "@/services/RestResourceService";

function initialState() {
    return {}
}

export default {
    state: initialState(),
    getters: {},
    mutations: {},
    actions: {
        POST_FILE_CONVERTER: async (context, payload) => {
            return RestResourceService.postResources(`/api/v1/converter/quasiris/tools/excel/to/csv`, payload.form)
                .then((response) => {
                    return response;
                })
                .catch((error) => {
                    errorParser.parse(error);
                    throw new Error(error);
                })
        }
    }
}
